import { UseMutationResult } from '@tanstack/react-query';

import { getExtensionRequestsReportCsv, useBaseReportCsv } from 'api';

export const useExtensionRequestsReportCsv = (): UseMutationResult<Blob> =>
  useBaseReportCsv(getExtensionRequestsReportCsv);
